<template>
  <div>
    <div style="text-align: left;" :class="menuFixed == true ? 'isFixed' :''">
      <el-row id="menu" style="background-color: #F0F0EE; padding-right: 20px">        
        <slot name="button-group-right-toggle"></slot>
        
        <el-col :span="8" style="text-align: left; background-color: #F0F0EE;">
          <div class="ion" v-if="hasBack" @click="goBack" style="margin-left: 10px">
            <ios-return-left-icon w="20px" h="20px" style="color: #333333; margin: 15px 15px; cursor: pointer;" />
          </div>
          <div class="ion" @click="goHome">
            <md-home-icon  w="20px" h="20px" style="color: #333333; margin: 15px 15px; cursor: pointer;" />
          </div>
          <div class="ion" v-if="hasNext" @click="goNext">
            <ios-return-right-icon w="20px" h="20px" style="color: #333333; margin: 15px 15px; cursor: pointer;" />
          </div>
        </el-col>

        <el-col :span="16" style="text-align: right; background-color: #F0F0EE;">
          <el-row>
            <div style="display: inline-block; vertical-align: top;">
              <transition name="el-fade-in-linear" >
                <div v-show="showMenu">
                  <div class="menu-element">Package History</div>
                  <div class="menu-element">Statistic</div>
                  <el-badge :value="12" class="item">
                    <div class="menu-element">History</div>
                  </el-badge>
                </div>
              </transition>
            </div>
            <div class="ion" @click="showMenu = !showMenu">
              <md-code-working-icon v-if="!showMenu" w="20px" h="20px" style="color: #333333; margin: 15px 10px; cursor: pointer; user-select: none;" />
              <md-code-icon v-if="showMenu" w="20px" h="20px" style="color: #333333; margin: 15px 10px; cursor: pointer; user-select: none;" />
            </div>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div v-if="menuFixed" id='marginForMenu'>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'head-menu',
    props: {
      isHomePage: Boolean,
      hasBack: Boolean,
      hasNext: Boolean,
    },
    data() {
      return {
        menuFixed: false,
        offsetTop: 0,
        showMenu: false,
      }
    },
    created() {
      window.addEventListener("scroll", this.handleScroll);//监听滑动事件
      window.addEventListener("resize", this.handleResize);//监听滑动事件
    },
    mounted() {
      this.offsetTop = document.querySelector('#menu').offsetTop
    },
    methods: {
      goHome() {
        if (this.isHomePage) {
          this.$router.go(0);
        } 
        else {
          this.$router.push({
            path: "/choose_city",
          });
          let lang = JSON.parse(sessionStorage.getItem("lang"));
          let user = JSON.parse(sessionStorage.getItem("User"));
          let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
          sessionStorage.clear();
          sessionStorage.setItem("lang", JSON.stringify(lang));
          sessionStorage.setItem("User", JSON.stringify(user));
          sessionStorage.setItem("UserAuthority", JSON.stringify(UserAuthority));
        }
      },
      goBack() {
        this.$emit('go-back-click')
      },
      goNext() {
        this.$emit('go-next-click')
      },
      handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > this.offsetTop) {
          this.menuFixed = true
        } else {
          this.menuFixed = false
        }
      },
      handleResize() {
        //this.offsetTop = document.querySelector('#menu').offsetTop
      }
    },
    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);//监听滑动事件
    },
  }
</script>

<style lang="scss" scoped>
  .isFixed{
    @media (max-width:767px) {
      position:fixed;
      width: calc(100% - 40px);
      margin:0 20px;
      height: 40px;
      top:0;
      left: 0;
      z-index:999;
    }
  }

  #marginForMenu {
    @media (max-width:767px) {
      padding-top: 40px;
    }
  }

  .menu-element {
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    margin: 8px 5px;
    padding: 5px 10px;
    border: 1px solid #4d4d4d;
    border-radius: 19px;
    color: #4d4d4d;
    cursor: pointer;
    user-select: none;
  }

  /deep/ .el-badge__content {
    top: 10px;
    right: 20px
  }
</style>


